import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Timeline from './components/Timeline';
import HotFeed from './components/HotFeed';
import Featured from './components/Featured';
import Principles from './components/Principles';
import FaqSection from './components/FaqSection';
import About from './components/About';
import Footer from './components/Footer';
import BackTop from './components/BackTop';
import { faqs } from '@/mocks/gossip';

function JsonLd() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '吃瓜大全 · 热门事件合集',
    url: 'https://celpipedu.cn/',
    description: '吃瓜大全热门事件合集，每日更新今日汇总与最新瓜料，热点事件打包整理，一站在手吃瓜不愁。',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '吃瓜大全',
    description: '专注于热门事件合集与每日热点汇总的内容平台。',
    url: 'https://celpipedu.cn/',
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </>
  );
}

export default function Home() {
  const [query, setQuery] = useState('');

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd />
      <Navbar />
      <main>
        <Hero onSearch={(q) => setQuery(q)} />
        <Timeline />
        <HotFeed query={query} />
        <Featured />
        <Principles />
        <FaqSection />
        <About />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}